import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getDateWithoutTime } from 'components/global/utils';
import { SkuDistrictParams } from '@api/order-reporting/types-deliveries/DeliveriesParams';
import { SkuDistrictReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { SkuDistrictReportGridData } from '@pages/reporting-pages/deliveries-sku-district/types/SkuDistrictReportGridData';
import { convertToGridData } from '@pages/reporting-pages/deliveries-sku-district/store/convertors';
import { DateRange } from '@project-types/DateRange';



interface ReportingDeliveriesSkuDistrictState {
	gridData: SkuDistrictReportGridData[] | null,
	dateRange: DateRange | null,
	materialId: string | null,
};

const initialState: ReportingDeliveriesSkuDistrictState = {
	gridData: null,
	dateRange: null,
	materialId: null,
};



export const reportingDeliveriesSkuDistrictSlice = createSlice({
	name: 'reportingDeliveriesSkuDistrict',
	initialState,
	reducers: {
		createGridData: (state, action: PayloadAction<SkuDistrictReport[] | undefined | null>) => {
			state.gridData = convertToGridData(action.payload);
		},
		setDateRange: (state, action: PayloadAction<DateRange>) => {
			state.dateRange = action.payload;
		},
		setMaterialId: (state, action: PayloadAction<string | null>) => {
			state.materialId = action.payload;
		},
		setSearchParameters: (state, action: PayloadAction<SkuDistrictParams>) => {
			let stateFrom = state.dateRange ? state.dateRange.from : null;
			let paramFrom = action.payload.dateFrom ? getDateWithoutTime(action.payload.dateFrom) : null;
			let stateTo = state.dateRange ? state.dateRange.to : null;
			let paramTo = action.payload.dateTo ? getDateWithoutTime(action.payload.dateTo) : null;
			if (stateFrom !== paramFrom || stateTo !== paramTo) {
				state.dateRange = paramFrom && paramTo ? { from: paramFrom, to: paramTo } : null;
			}
			if (action.payload.materialId !== state.materialId) {
				state.materialId = action.payload.materialId ? action.payload.materialId : null;
			}
		},
		resetStore: (_) => initialState,
	},
});



export const {
	createGridData,
	setDateRange,
	setMaterialId,
	setSearchParameters,
	resetStore } = reportingDeliveriesSkuDistrictSlice.actions;